// utils/binanceConstants.js
const BINANCE = 'binance'
const OKX = 'okx'

const CROSS = 'cross'
const ISOLATED = 'isolated'

const LONG = 'LONG'
const SHORT = 'SHORT'

const BUY = 'BUY'
const SELL = 'SELL'

const LIMIT = "LIMIT"
const MARKET = "MARKET"
const STOP_LOSS = "STOP_LOSS"
const TAKE_PROFIT = "TAKE_PROFIT"
const TAKE_PROFIT_MARKET = "TAKE_PROFIT_MARKET"
const STOP_MARKET = "STOP_MARKET"
const TRAILING_STOP_MARKET = "TRAILING_STOP_MARKET"

const MARK_PRICE = "MARK_PRICE"
const CONTRACT_PRICE = "CONTRACT_PRICE"


module.exports = {
    BINANCE,
    OKX,
    CROSS,
    ISOLATED,
    LONG,
    SHORT,
    BUY,
    SELL,
    LIMIT,
    MARKET,
    STOP_LOSS,
    TAKE_PROFIT,
    TAKE_PROFIT_MARKET,
    STOP_MARKET,
    TRAILING_STOP_MARKET,
    MARK_PRICE,
    CONTRACT_PRICE
}
